<script setup>
  import { ref } from 'vue'

  const open = ref(false)

  defineProps({
    email: String,
    phone: String,
  })

</script>

<template>
  <div
    class="fixed ~bottom-4/10 ~right-4/10 z-50"
  >
    <a
      @click="open = !open"
      :href="`tel:${phone}`"
      aria-label="Rufen Sie uns an"
      class="bg-secondary absolute flex items-center justify-center ~h-10/14 ~w-10/14 shadow-lg hover:shadow-2xl rounded-full transition-all duration-300 ease-in-out"
      :class="open ? 'open pointer-events-auto opacity-100 right-20' : 'pointer-events-none opacity-0 right-0'"
    >
      <AppIcon
        name="CtaPhone"
      />
    </a>
    <a
      @click="open = !open"
      :href="`mailto:${email}`"
      aria-label="Schreiben Sie uns eine E-Mail"
      class="bg-secondary absolute flex items-center justify-center ~h-10/14 ~w-10/14 shadow-lg hover:shadow-2xl rounded-full transition-all duration-300 ease-in-out delay-200"
      :class="open ? 'open pointer-events-auto opacity-100 right-10 bottom-20' : 'pointer-events-none right-0 bottom-0 opacity-0'"
    >
      <AppIcon
        name="CtaEmail"
      />
    </a>
    <button
      @click="open = !open"
      aria-label="Nehmen Sie Kontakt mit uns auf"
      class="bg-primary flex items-center justify-center ~h-12/16 ~w-12/16 shadow-md rounded-full transition-all duration-300 ease-in-out"
      :class="open ? '-rotate-90 shadow-3xl' : 'hover:-rotate-12 hover:shadow-xl'"
    >
      <AppIcon
        name="ShareArrow"
      />
    </button>
  </div>
</template>

<style lang="scss" scoped>
  a {
    :deep(svg path) {
      @apply fill-primary !important;
    }
  }
</style>
